import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to Sunspot",
    title: "Harness the Power of the Sun",
    content: "Discover efficient and sustainable solar solutions designed to power your home and business while reducing your carbon footprint.",
    buttonText: "Learn More",
    buttonLink: "About-us",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to Sunspot",
    title: "Innovative Solar Technology",
    content: "Explore cutting-edge solar panels and energy systems tailored to maximize efficiency and deliver reliable green energy all year round.",
    buttonText: "Learn More",
    buttonLink: "About-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to Sunspot",
    title: "Expert Solar Installation Services",
    content: "Benefit from professional installation, maintenance, and consultation to ensure your solar investment performs at its best.",
    buttonText: "Learn More",
    buttonLink: "About-us",
  },
];

export default home;